<button (click)="click()" matRipple>
  <img [src]="avatarUrl()" />
</button>

<div
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  [matMenuTriggerRestoreFocus]="false"
  class="trigger"
></div>
<mat-menu #menu="matMenu">
  <button mat-menu-item routerLink="/user/profile">
    <mat-icon>account_circle</mat-icon>
    个人资料
  </button>
  <button mat-menu-item (click)="openWallet()">
    <mat-icon>account_balance_wallet</mat-icon> 我的钱包
  </button>
  <button mat-menu-item routerLink="/user/profile/seats">
    <mat-icon>local_activity</mat-icon> 我的车票
  </button>
  <button mat-menu-item routerLink="/user/profile/form">
    <mat-icon>description</mat-icon> 我的工单
  </button>
  <button mat-menu-item routerLink="/user/profile/affiliate">
    <mat-icon>share</mat-icon> 我的推广
  </button>
  <button mat-menu-item routerLink="/user/profile/orders">
    <mat-icon>receipt_long</mat-icon> 订单记录
  </button>
  <!-- <button mat-menu-item routerLink="/trending">
    <mat-icon>feed</mat-icon> 动态资讯
  </button> -->

  <mat-divider></mat-divider>
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon> 退出登录
  </button>
</mat-menu>
